import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import { api } from '~/api/client'
import { ArtHeading } from '~/components/member/Illustration'
import { MemberLayout } from '~/components/member/layout'
import { useT } from '~/i18n/use-t'
import { pathForStatus, registrationEndedPath } from '~/lib/flow'
import { Wait } from './Wait'

/**
 * `/join/return` (the page a hosted provider sends the member back to): "we are checking your result", then the
 * same polling as S4-wait. Nothing on this page trusts the address: the result comes from the server.
 *
 * Two flows come back here: a registration (registration cookie) and a member's face check again from `/me/face`
 * (member session, no registration cookie). A 401 on the registration status therefore asks who is there: a logged-in
 * member goes to `/me`, where the check's result shows; anyone else's registration has ended (the welcome page).
 */
export default function ReturnPage() {
  const { t } = useT()
  const navigate = useNavigate()
  const onLoggedOut = useCallback(() => {
    api('memberMe').then(
      () => navigate('/me', { replace: true }),
      () => {
        const ended = registrationEndedPath()
        navigate(ended.to, { replace: true, state: ended.state })
      }
    )
  }, [navigate])
  return (
    <MemberLayout flow>
      <ArtHeading title={t('wait.returnTitle')} art='wait' />
      <Wait
        heading={false}
        onDecided={(r) => navigate(pathForStatus(r), { replace: true })}
        onLoggedOut={onLoggedOut}
      />
    </MemberLayout>
  )
}
